// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_DsC","cls2":"Unibrow-cls2_ziT Unibrow-cls1_DsC"};